import { useState } from "react";
import { Plus, Pencil, Trash2, Send } from "lucide-react";
import { toast } from "sonner";
import { setProposte, clearProposte } from "./clubApi";
import { Btn, Card, Pill } from "./ui";
import PlanEditor from "./PlanEditor";

export default function ProposteEditor({ cliente, onChanged }) {
  const saved = cliente.piano.proposte || [];
  const [list, setList] = useState(saved);
  const [editing, setEditing] = useState(null); // index | "new" | null
  const [busy, setBusy] = useState(false);
  const dirty = JSON.stringify(list) !== JSON.stringify(saved);

  const upsert = (payload) => {
    const next = editing === "new" ? [...list, { id: null, ...payload }] : list.map((p, i) => (i === editing ? { ...p, ...payload } : p));
    setList(next); setEditing(null);
  };
  const send = async () => {
    setBusy(true);
    try { await setProposte(cliente.id, list); toast.success(saved.length ? "Proposte aggiornate sulla pagina del cliente" : "Proposte inviate: il cliente ora può scegliere"); onChanged(); } catch (e) { toast.error(e?.response?.data?.detail || "Errore nell'invio"); }
    setBusy(false);
  };
  const removeAll = async () => {
    if (!window.confirm("Ritirare tutte le proposte dalla pagina del cliente?")) return;
    await clearProposte(cliente.id); setList([]); toast.message("Proposte ritirate"); onChanged();
  };

  return (
    <div className="mt-3 space-y-3" data-testid="proposte-editor">
      {list.length === 0 && editing === null && (
        <Card className="text-sm text-[#9A948A] border-dashed">Puoi preparare fino a 4 idee diverse (es. «Partenza leggera» e «Completa»): il cliente le vede sulla sua pagina e sceglie quella che sente più sua. Appena sceglie, il percorso parte e tu ricevi un'email.</Card>
      )}
      {list.map((p, i) => (
        editing === i ? (
          <PlanEditor key={p.id || i} cliente={cliente} initial={p} withTitle saveLabel="Salva proposta" onSave={upsert} onCancel={() => setEditing(null)} />
        ) : (
          <Card key={p.id || i} className="space-y-2" data-testid={`proposta-${i}`}>
            <div className="flex items-center justify-between gap-2">
              <p className="font-semibold">{p.titolo}</p>
              <div className="flex items-center gap-2">
                <Pill tone="muted">{p.durata_giorni} gg</Pill>
                <button onClick={() => setEditing(i)} className="text-[#9A948A] hover:text-white" data-testid={`proposta-edit-${i}`}><Pencil size={14} /></button>
                <button onClick={() => setList(list.filter((_, j) => j !== i))} className="text-[#9A948A] hover:text-[#ff9a9e]" data-testid={`proposta-remove-${i}`}><Trash2 size={14} /></button>
              </div>
            </div>
            <p className="text-xs text-[#9A948A]">{p.prodotti.map((x) => x.nome).join(" · ")}</p>
            {p.note && <p className="text-xs italic text-[#F4EFE6]/70">"{p.note}"</p>}
          </Card>
        )
      ))}
      {editing === "new" && <PlanEditor cliente={cliente} initial={{ prodotti: list.length ? [] : cliente.piano.prodotti, note: "", durata_giorni: 30 }} withTitle saveLabel="Salva proposta" onSave={upsert} onCancel={() => setEditing(null)} />}
      {editing === null && (
        <div className="flex flex-wrap gap-2">
          {list.length < 4 && <Btn variant="ghost" className="px-4 py-2 text-xs" onClick={() => setEditing("new")} data-testid="proposta-add"><Plus size={14} /> {list.length ? "Altra proposta" : "Prima proposta"}</Btn>}
          {list.length > 0 && (dirty || !saved.length) && <Btn className="px-4 py-2 text-xs" onClick={send} disabled={busy} data-testid="proposte-send"><Send size={14} /> {busy ? "Invio…" : saved.length ? "Aggiorna sulla pagina" : `Invia ${list.length === 1 ? "la proposta" : `le ${list.length} proposte`}`}</Btn>}
          {saved.length > 0 && <button onClick={removeAll} className="text-xs text-[#6F6A62] hover:text-[#ff9a9e] px-2" data-testid="proposte-clear">Ritira</button>}
        </div>
      )}
    </div>
  );
}
